import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import { useState } from "react";
import { AuthProvider } from "../features/auth/AuthProvider.jsx";
import { TelegramAuthBootstrap } from "../features/auth/TelegramAuthBootstrap.jsx";

export function AppProviders({ children, authClient }) {
  const [queryClient] = useState(
    () =>
      new QueryClient({
        defaultOptions: {
          queries: {
            refetchOnWindowFocus: false,
            retry: 1,
            staleTime: 30_000,
          },
        },
      }),
  );

  return (
    <AuthProvider client={authClient}>
      <TelegramAuthBootstrap>
        <QueryClientProvider client={queryClient}>{children}</QueryClientProvider>
      </TelegramAuthBootstrap>
    </AuthProvider>
  );
}
